import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { SubscriptionTypes } from 'entities/subscription';

import './index.css';

const SubscriptionsIOS = ({ subscriptions, user }) => {
  const { t } = useTranslation();

  if (!user?.inSignedIn) {
    return null;
  }

  return (
    <>
      <div className="container-full-page subscription-managment">
        <h1 className="subscription-managment__title">
          {t('subscriptions.subscriptions_management')}
        </h1>
        <div className="subscription-managment__subscriptions">
          <div className="table-wrapper">
            <table cellSpacing="0">
              <thead>
                <tr>
                  <th>{t('subscriptions.subscription')}</th>
                  <th>{t('subscriptions.date_start')}</th>
                  <th>{t('subscriptions.date_end')}</th>
                  <th>{t('subscriptions.next_charge_amount')}</th>
                </tr>
              </thead>
              <tbody>
                {!!subscriptions.receipt && (
                  <tr>
                    <td>{subscriptions.receipt.plan}</td>
                    <td>{`${new Date(
                      subscriptions.receipt.purchaseDate
                    ).getFullYear()}-${
                      new Date(subscriptions.receipt.purchaseDate).getMonth() +
                      1
                    }-${new Date(
                      subscriptions.receipt.purchaseDate
                    ).getDate()}`}</td>
                    <td>
                      {subscriptions.receipt.plan !== SubscriptionTypes.forever
                        ? `${new Date(
                            subscriptions.receipt.expiresDate
                          ).getFullYear()}-${
                            new Date(
                              subscriptions.receipt.expiresDate
                            ).getMonth() + 1
                          }-${new Date(
                            subscriptions.receipt.expiresDate
                          ).getDate()}`
                        : 'Forever'}
                    </td>
                    <td>
                      {subscriptions.receipt.plan !== SubscriptionTypes.forever
                        ? `${subscriptions.receipt.nextChargeAmount / 1000} ${
                            subscriptions.receipt.currency
                          }`
                        : 'No further invoice'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  subscriptions: state.subscriptions,
  user: state.user
});

export default connect(mapStateToProps)(SubscriptionsIOS);
